import { render } from "./TabView.vue?vue&type=template&id=77fa9e54&scoped=true"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"

import "./TabView.vue?vue&type=style&index=0&id=77fa9e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fa9e54"]])

export default __exports__